import { FC, ReactNode } from "react";
import { GitbookEmbedComponent } from "./gitbook-embed";
import { GitbookHintComponent } from "./gitbook-hint";

export interface GitbookUnifiedProps {
  children?: ReactNode;
  node?: any;
  url?: string;
  [key: string]: any;
}

/**
 * Unified GitBook component that handles different shortcode types
 */
export const MarkdownComponentGitbook: FC<GitbookUnifiedProps> = (props) => {
  const { children, url, node, ...restProps } = props;

  // Determine the shortcode type from the node's tag name
  const shortcodeType = node?.tagName?.replace("gitbook-", "") || "unknown";

  // Handle embed shortcodes
  if (shortcodeType === "embed") {
    return <GitbookEmbedComponent url={url} {...restProps} />;
  }

  // Handle hint shortcodes
  if (shortcodeType === "hint") {
    return <GitbookHintComponent {...props} />;
  }

  // Fallback for unknown shortcode types
  return (
    <div className="my-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <p className="text-sm text-gray-600">
        Unknown GitBook shortcode: {shortcodeType}
      </p>

      {children && <div className="mt-2">{children}</div>}
    </div>
  );
};
